import { handleActions } from 'redux-actions'
import { fromJS, Map as ImmutableMap } from 'immutable'

import * as Actions from 'actions/alerts'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  selectedAlertId: null,
  selectedAlert: null
})

export default handleActions({
  [Actions.showAlertDialog]: (state, { payload: alertId }) => state
    .set('selectedAlertId', alertId == null ? null : alertId)
    .set('selectedAlert', null),
  [Actions.showCreateAlertDialog]: (state, { payload: alert }) => state
    .set('selectedAlertId', null)
    .set('selectedAlert', ImmutableMap.isMap(alert) ? alert : fromJS(alert)),
  [Actions.updateSelectedAlert]: (state, { payload: alert }) => state.set('selectedAlert', alert),
  [Actions.hideAlertDialog]: () => initialState,
  [AppActions.resetState]: () => initialState
}, initialState)
